import React, { useState, useEffect, useRef } from "react";
import { Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import { AddImgLogo } from "../../../assets/icons";
import InputField from "../../../components/form/InputField";
import CommonButton from "../../../components/commonButton";
import { addBankSchema } from "../../../schema/validationSchemas";
import { FormFeedback } from "../../../components/form/utils";
import withModal from "../../../components/withModal";

const BankModalInner = ({
    onClose,
    isEditMode,
    editBankData,
    onSubmit,
}) => {
    const [addBankImgName, setAddBankImgName] = useState("");
    const [addBankPreviewImg, setAddBankPreviewImg] = useState("");
    const nameInputRef = useRef(null);

    const initialEventState = {
        bank_name: editBankData?.name || "",
        logo: editBankData?.logo?.url || "",
    };

    useEffect(() => {
        setTimeout(() => {
            nameInputRef.current?.focus();
        }, 200);
    }, []);

    useEffect(() => {
        if (editBankData) {
            setAddBankPreviewImg(editBankData?.logo?.url || "");
            setAddBankImgName("");
        } else {
            setAddBankPreviewImg("");
            setAddBankImgName("");
        }
    }, [editBankData]);

    const handleSubmit = async (values, { setSubmitting }) => {
        const formData = new FormData();
        formData.append("name", values?.bank_name);
        if (values?.logo instanceof File) {
            formData.append("file", values?.logo);
        }
        try {
            await onSubmit(formData);
            onClose();
        } catch (err) {
            // Handled by onSubmit caller
        } finally {
            setSubmitting(false);
        }
    };

    return (<Formik
        initialValues={initialEventState}
        validationSchema={addBankSchema}
        validateOnBlur={false}
        onSubmit={handleSubmit}
        enableReinitialize
    >
        {({
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleBlur,
            values,
            setFieldValue,
            handleSubmit,
        }) => (
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className="d-flex flex-column gap-1 justify-content-center align-items-center">
                        <div className="overflow-hidden position-relative d-flex align-items-center justify-content-center rounded-circle bg-white mx-auto" style={{ height: "72px",width: "72px",border: "1px dashed var(--primary)"}}>
                            {addBankPreviewImg ? (
                                <img
                                    src={addBankPreviewImg}
                                    className="object-fit-cover d-inline-block mx-auto"
                                    height={70}
                                    width={70}
                                    alt={addBankImgName || "Preview"}
                                />
                            ) : (
                                <div className="text-center">
                                    <AddImgLogo />
                                </div>
                            )}

                            <input
                                type="file"
                                name="logo"
                                accept="image/*"
                                onChange={(event) => {
                                    const file = event.currentTarget.files[0];
                                    if (file) {
                                        setFieldValue("logo", file);
                                        setAddBankImgName(file.name);
                                        setAddBankPreviewImg(URL.createObjectURL(file));
                                    }
                                }}
                                className="position-absolute z-1 top-0 bottom-0 start-0 end-0 cursor-pointer opacity-0"
                            />
                        </div>
                        <span className="fw-semibold primary fs-sm">
                            {addBankImgName ? addBankImgName : "Choose Logo"}
                        </span>
                    </div>
                    <div className="text-center">
                        {touched.logo && errors.logo ? (
                            <FormFeedback message={errors.logo} />
                        ) : null}
                    </div>
                    <InputField
                        label={{ name: "Bank Name" }}
                        ref={nameInputRef}
                        input={{
                            id: "bank_name",
                            name: "bank_name",
                            type: "text",
                            value: values.bank_name,
                            placeholder: "Ex. ICICI Bank Ltd",
                            onChange: handleChange,
                            onBlur: handleBlur,
                        }}
                        validation={{
                            isInvalid: touched.bank_name && errors.bank_name,
                            message: errors.bank_name,
                        }}
                    />


                </Modal.Body>
                <Modal.Footer className="justify-content-center">

                    <CommonButton
                        title={isEditMode ? "Update Bank" : "Add Bank"}
                        type="submit"
                        disabled={isSubmitting}

                    />

                </Modal.Footer>   </Form>
        )}
    </Formik>
    );
};

const BankModal = withModal(BankModalInner);
export default BankModal;